import React from 'react';

//Styles
import './Portfolio.scss';

//SVG icons
import Dots from '../Icons/Dots';
import Square from '../Icons/Square';

//Components
import PortfolioItemSlider from '../Components/PortfolioItemSlider';
import PortfolioItemSlider_2 from '../Components/PortfolioItemSlider_2';
import PortfolioItemSlider_3 from '../Components/PortfolioItemSlider_3';

function Portfolio() {
    return (
        <div className="portfolioView">
            <div className="container">
                <div className="intro section">
                    <h2>Portfolio <Dots /></h2>
                    <Square />

                    <div className="container-inner">
                        <div className="text">
                            <p>We GOLD CONSTRUCTION LIMITED, one of the growing construction company in Zambia. We have a broad portfolio of successfully completed projects across a range of sectors including Industrial, Commercial, Residential, Restoration, Refurbishment and Hospitality</p>

                            <p>We are known for our client focus and hands-on approach. We are proud of the fact that the majority of our workload comes from our existing clients and that we have a strong reputation for our competitive edge and reliable execution of all projects undertaken. This is achieved through our relentless attention to detail and an experienced team with the drive and customer focus to ensure client delight.</p>

                            <p>We continue to invest in modern business practices and management techniques

                                in order to ensure that we retain the cutting edge in our industry. We continue to scale

                                new heights with our focus firmly on growing the ability & capacity of our business is in

                                terms of Manpower or Machinery to deliver in new and innovative ways.

                                Our ambition and goals always been to deliver quality projects and value for money

                                to our clients; our success and reputation today have been testament to this

                                vision of ours.</p>

                            <p>
                                We have well developed and comfortable working atmosphere with high Tech

                                machines in Zambia's most progressive city and business hub of Lusaka, Zambia.
                            </p>

                            <p>
                                The company was incorporated in the year 2019, during our construction process each section is closely monitored through the inspection during every stage of completion. The final Inspections are under the highly experienced and qualified person. ensures that the construction meets the exact requirements.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="portfolio section">
                    <div className="container-inner">
                        <div className="portfolio-container">
                            <div className="portfolio-item">
                                <h3> Redesign and Refurbishment Construction<Square /> </h3>

                                <p>We do renovation and refurbishment projects for residential and commercial setups.</p>
                                <PortfolioItemSlider />
                            </div>

                            <div className="portfolio-item">
                                <h3> Exterior and Interior Design with Equipment Integration. <Square /> </h3>

                                <p>For commercial projects such as fuel stations and other plants.</p>
                                <PortfolioItemSlider_2 />
                            </div>

                            <div className="portfolio-item">
                                <h3>Custom Fabrication And Installation <Square /></h3>

                                <p>Along with your exterior and interior design we can also create bespoke elements for your vision from one of a kind light designs, shelf designs ,furniture designs, gates, to water features and the clients branding and fabrication needs. This lets our clients have the flexibility and confidence in bringing their vision to life and elevate the finishing even further.</p>

                                <PortfolioItemSlider_3 />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Portfolio;